<template>
  <div>
    <el-menu
        active-text-color="#1890FF"
        background-color="#001529"
        text-color="#F3F3F3"
        style="width: 150px; min-height: calc(100vh - 70px)"
        :default-active="1"
        router
        class="el-menu-vertical-demo"
        @select="handleSelect"
    >
      <div  v-for="m in asideRouter" :key="m.id">
        <el-menu-item :index="m.path">
          <span style="font-size: 15px;font-weight: bold;">{{ m.comment }}</span>
        </el-menu-item>
      </div>
      <!--<el-menu-item :index="1">-->
        <!--<span>导航</span>-->
      <!--</el-menu-item>-->
    </el-menu>
  </div>
</template>

<script>
import request from "@/utils/request";
import { MAIL_CALENDAR_CHAT_WRITEBACK_ENABLED } from "@/config/features";

export default {
  name: "Aside",
  data() {
    return {
      user: {},
      asideRouter: [],
    }
  },
  created() {
    let userStr = sessionStorage.getItem("user") || "{}"
    this.user = JSON.parse(userStr)
    let routerMap = new Map();
    routerMap.set('1',[
      {
        id: 1,
        path: "adminView",
        comment: "所有公司"
      },
      {
        id: 2,
        path: "config",
        comment: "公司信息"
      },
      {
        id: 3,
        path: "personConfig",
        comment: "员工信息"
      },
      {
        id: 4,
        path: "viewFile",
        comment: "文件信息"
      }
    ]);
    if (MAIL_CALENDAR_CHAT_WRITEBACK_ENABLED) {
      routerMap.get('1').push({
        id: 5,
        path: "outlookConfig",
        comment: "邮箱配置"
      });
    }
    routerMap.set('2',[
      {
        id: 1,
        path: "config",
        comment: "公司信息"
      },
      {
        id: 2,
        path: "personConfig",
        comment: "员工信息"
      },
      {
        id: 3,
        path: "viewFile",
        comment: "文件信息"
      }
    ]);
    routerMap.set('3',[
      {
        id: 1,
        path: "personConfig",
        comment: "员工信息"
      },
      {
        id: 2,
        path: "viewFile",
        comment: "文件信息"
      }
    ]);
    if(this.user != null){
      this.asideRouter = routerMap.get(this.user.profileCode);
    }

    // 请求服务端，确认当前登录用户的 合法信息
    // request.get("/user/" + this.user.id).then(res => {
    //   if (res.code === '0') {
    //     this.user = res.data
    //   }
    // })
  },
  methods: {
    handleSelect(key, keyPath){
      console.log(key, keyPath);
    }
  }
}
</script>

<style scoped>

</style>
